module.exports = __webpack_public_path__ + "img/product.893c6b60.png";